import { GLASS_WALL } from '../../types/wallTypes';

const isGlassWall = (selectedWall: any): boolean =>
  selectedWall.properties.wallType.startsWith(GLASS_WALL);

export default isGlassWall;
